import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import LabelAndHint from '../LabelAndHint/LabelAndHint';
var css = {
  "checkbox": "rui-lGjKM"
};
import Checkbox from '../Checkbox/Checkbox';
var MultiSelect = /*#__PURE__*/function (_Component) {
  _inherits(MultiSelect, _Component);
  var _super = _createSuper(MultiSelect);
  function MultiSelect() {
    var _this;
    _classCallCheck(this, MultiSelect);
    _this = _super.apply(this, arguments);
    _this.handleOnChange = function (newValue) {
      var newArray;
      if (_this.props.values.find(function (value) {
        return value === newValue;
      })) {
        newArray = _this.props.values.filter(function (value) {
          return value !== newValue;
        });
      } else {
        newArray = [].concat(_toConsumableArray(_this.props.values), [newValue]);
      }
      _this.props.onChange(newArray, _this.props.name);
    };
    _this.renderInput = function () {
      var onChange = function onChange(value) {
        return function () {
          return _this.handleOnChange(value);
        };
      };
      return /*#__PURE__*/React.createElement("div", null, _this.props.options.map(function (option) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          key: option.key,
          id: "checkbox-".concat(option.key),
          label: option.name,
          value: _this.props.values.find(function (value) {
            return value === option.key;
          }) ? !!option.key : false,
          onChange: onChange(option.key),
          className: css.checkbox,
          disabled: _this.props.disabled
        });
      }));
    };
    return _this;
  }
  _createClass(MultiSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LabelAndHint, {
        id: this.props.id,
        label: this.props.label,
        value: this.props.values,
        pristine: this.props.pristine,
        hintText: this.props.hintText,
        errorText: this.props.errorText,
        disabled: this.props.disabled,
        render: this.renderInput,
        highlightInput: false
      });
    }
  }]);
  return MultiSelect;
}(Component);
MultiSelect.defaultProps = {
  disabled: false,
  errorText: '',
  hintText: '',
  label: '',
  onChange: function onChange() {},
  pristine: true,
  values: []
};
export default MultiSelect;